import { render, staticRenderFns } from "./TambahPresensi.vue?vue&type=template&id=ccde3478&scoped=true"
import script from "./TambahPresensi.vue?vue&type=script&lang=js"
export * from "./TambahPresensi.vue?vue&type=script&lang=js"
import style0 from "./TambahPresensi.vue?vue&type=style&index=0&id=ccde3478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccde3478",
  null
  
)

export default component.exports